export default __webpack_public_path__ + "static/media/new_need_help_icon.d3591553.svg";